module.exports = __webpack_public_path__ + "img/hexagon-xmark.9c213fdf.svg";